export default function getCurrencySign(currency) {
  if(currency === "EUR") {
    return "€";
  }
  if(currency === "USD") {
    return "$";
  }
  if(currency === "RUB") {
    return '₽';
  }

  return '';
}
